import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { router } from '@/router';
import { useTheme } from '@/hooks/useTheme';
import { AuthProvider } from '@/features/auth/AuthProvider';

export default function App(): JSX.Element {
  useTheme();
  return (
    <AuthProvider>
      <RouterProvider router={router} />
      <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
    </AuthProvider>
  );
}
